import { Center } from '@chakra-ui/react';
import React from 'react';
import Lottie from 'react-lottie';
import animationData from '../../../animations/animationLoader.json';

export const Inner: React.FC<{
    children?: React.ReactNode;
    speed?: number;
    animationData?: unknown;
}> = React.memo((props) => (
    <Center height="100%">
        <Lottie
            options={{
                loop: true,
                autoplay: true,
                animationData,
            }}
            speed={props.speed}
            height={50}
            width={50}
        />
    </Center>
));

// Hack to fix issue described here https://github.com/chenqingspring/react-lottie/issues/51#issuecomment-2464729633
export const CardSpinner: React.FC<{ children?: React.ReactNode; speed?: number }> = (
    props
) => {
    return <Inner {...props} animationData={animationData} />;
};
